import axios from 'axios'

const api = axios.create({
    baseURL: 'https://gsehelp.com/api',
});
  
const DOWNLOADS_URL = 'https://pcswebsite.s3.us-east-1.amazonaws.com/gsehelp/downloads.json';

export async function getDownloadsByType(type) {
    try {
        const response = await axios.get(DOWNLOADS_URL);
        return response.data?.[type] ?? [];
    } catch (error) {
        console.error(error);
        return [];
    }
}

export default api;

